<template>
    <span class="custom-tooltip custom-tooltip-wrapper" role="tooltip">
        
        <font-awesome-icon :icon="iconClass" @mouseover="getPopupRightPosition($event)"/>

        <div class="custom-tooltip-content" :style="styles" v-if="contentType === 'html'" :v-html="content"></div>
        <div class="custom-tooltip-content" :style="styles" v-if="contentType === 'text'">{{ content }}</div>

    </span>
</template>

<script>

export default {
    name: 'CustomTooltip',
    props: {
        iconClass: {
            type: String, //font awesome icon classes
            required: false,
        },
        contentType: {
            type: String,
            required: false,
            default: 'text', // text/html
        },
        content: {
            type: String,
            required: true
        }
    },
    data(){
        return {
            styles: {
                right: "18px"
            }
        }
    },
    methods: {
        getPopupRightPosition(event) {
            const threshold = 350;//popup width set in the css section
            const windowWidth = window.innerWidth;
            const distanceOnLeft = event.clientX;
            const distanceOnRight = windowWidth - distanceOnLeft;

            if (distanceOnLeft < threshold){
                this.styles.right = `-${threshold - distanceOnLeft}px`
            } else if (distanceOnRight < threshold){
                this.styles.right = "18px"
            }

        }
    },
    mounted() {
        window.addEventListener("resize", this.getPopupRightPosition);
    },
    unmounted(){
        window.removeEventListener("resize", this.getPopupRightPosition);
    }
}

</script>

<style>
.custom-tooltip{
    position: relative;
    width: 18px;

    .custom-tooltip-content {
        position: absolute;
        bottom: 18px;
        right: 18px;
        max-width: 350px;
        width: 350px;
        z-index: 999;
        display: none;
        background: #212529;
        color: #ffffff;
        padding: 0.5rem 0.75rem;
        box-shadow: none;
        border-radius: 4px;
    }

    &:hover, &:focus{
        .custom-tooltip-content {
            display: inline-block;
        }
    }
}
</style>